import { createApi } from '@reduxjs/toolkit/query/react'
import { generateRPCQuery, getBaseQuery } from './apiUtils'
import apiConstants from './constants'

export const behaviorsApi = createApi({
  reducerPath: 'behaviorsApi',
  tagTypes: ['BehaviorsLogs'],
  refetchOnFocus: false,
  baseQuery: getBaseQuery(),
  endpoints: (builder) => ({
    getBehaviorsGroups: builder.query({
      query: (requestParams: GetBehaviorsGroupsParam) =>
        generateRPCQuery(
          apiConstants.BEHAVIORS_RPC_PATH,
          'getBehaviorsGroupsList',
          requestParams
        ),
      providesTags: ['BehaviorsLogs']
    }),
    getBehaviorsGroupInfoByID: builder.query({
      query: (requestParams: GetBehaviorDetailsParams) =>
        generateRPCQuery(
          apiConstants.BEHAVIORS_RPC_PATH,
          'getBehaviorsGroupInfoByID',
          requestParams
        )
    }),
    getDetailsForBehaviorDistinction: builder.query({
      query: (requestParams: { TenantID: string }) =>
        generateRPCQuery(
          apiConstants.BEHAVIORS_RPC_PATH,
          'getDetailsForBehaviorDistinction',
          requestParams
        )
    }),
    processBehaviors: builder.query({
      query: (requestParams: ProcessBehaviorsParams) =>
        generateRPCQuery(
          apiConstants.BEHAVIORS_RPC_PATH,
          'processBehaviors',
          requestParams
        )
    }),
    reportBehaviors: builder.mutation({
      query: (requestParams: ReportBehaviorsParams) =>
        generateRPCQuery(
          apiConstants.BEHAVIORS_RPC_PATH,
          'reportBehaviors',
          requestParams
        ),
      invalidatesTags: ['BehaviorsLogs']
    })
  })
})

export const {
  useGetBehaviorsGroupInfoByIDQuery,
  useGetBehaviorsGroupsQuery,
  useLazyProcessBehaviorsQuery,
  useGetDetailsForBehaviorDistinctionQuery,
  useReportBehaviorsMutation
} = behaviorsApi
